module.exports = __webpack_public_path__ + "static/media/settings.57ce510f.svg";